
<!-- <app-add-citizen></app-add-citizen> -->
<div class="pl-5 pt-5 mt-3">
    
    <router-outlet></router-outlet>
    <!-- <app-citizen-list></app-citizen-list> -->
</div>